export default __webpack_public_path__ + "public/assets/images/a8a85fb8632920cc70fc64d7d6ecfbeb.png";